export class CashAuditActions {
    public static COUNT = 'COUNT';
    public static IN = 'IN';
    public static OUT = 'OUT';
    public static MAKE_CHANGE = 'MAKE_CHANGE';
    public static TRANSFER = 'TRANSFER';
}
